<!--
    @负责人: 黎柏祺
    @创建时间: 2019-01-25
    @版本:v2.0.2
    @描述: 静态级别配置
-->
<template>
  <div class="staticConfig__content">
    <div class="appServiceConfig__form">
      <el-form ref="form" :model="form" :inline="true" input-width="auto"> 
        <el-form-item :label="$t('logComponentManage.appName')">
          <el-input v-model="form.appName"></el-input>
        </el-form-item> 
        <el-form-item :label="$t('logComponentManage.group')">
          <g-select :list="groupList" v-model="form.group" :default-all="true" ></g-select>
        </el-form-item>
        <el-form-item :label="$t('logComponentManage.ipSearch')">
          <el-input v-model="form.ip"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="e_search" v-g-rac="gRac('staticConfig@search')">{{ $t('common.search') }}</el-button>
          <el-button type="primary" @click="e_add()" v-g-rac="gRac('staticConfig@add')">{{ $t('common.add') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table-extend 
      :data="tData" 
      :head="tHead" 
      :currentChange="tCurrentChange" 
      :sizeChange="tSizeChange" 
      border>
    <template slot="control-column" slot-scope="{data}">
      <el-table-extend-control 
        :control="tableControl" 
        :data="data" 
        :label="$t('common.handle')">
      </el-table-extend-control>
    </template>
    </el-table-extend>
    <el-dialog :closeOnClickModal="false" :title="dialogTitle" :visible.sync="dialogFormShow" width="800px">
      <el-form :model="staticForm" label-position="right" label-width="120px" ref="staticForm" :rules="dialogFormRule">
        <el-form-item :label="$t('logComponentManage.group')" prop="group">
          <g-select :list="groupList" v-model="staticForm.group" :tdisabled="checked"></g-select>
        </el-form-item>
        <el-form-item :label="$t('logComponentManage.appName')" prop="appName">
          <g-select :list="select_app" v-model="staticForm.appName" :tdisabled="checked"></g-select>
        </el-form-item>
        <el-form-item :label="$t('logComponentManage.logLevel')" prop="logLevel">
            <g-select :list="select_log" v-model="staticForm.logLevel"></g-select>
        </el-form-item>
        <el-form-item :label="$t('logComponentManage.log1Level')" prop="log1Level">
            <g-select :list="select_log" v-model="staticForm.log1Level"></g-select>
        </el-form-item>
        <el-form-item :label="$t('logComponentManage.uploadLevel')" prop="uploadLevel">
            <g-select :list="select_log" v-model="staticForm.uploadLevel"></g-select>
        </el-form-item>
        <el-form-item input-width="550px" :label="$t('logComponentManage.instanceConfig')">
          <el-checkbox v-model="checked"></el-checkbox>
          <dynamic-table ref="dynamicTable" 
            :input-data="inputData" 
            :model="tableModel" 
            :custom-fun="deleteDdata"
            v-show="checked">
          </dynamic-table>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="e_cancel">{{$t('common.cancel')}}</el-button>
        <el-button type="primary" @click="e_save">{{$t('common.save')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
              
<script >
  import rac from '@/plugins/rac-mixin'
  import dic from '@/components/mixins/dic'
  import table from '@/components/mixins/table'
  import staticConfigBiz from '@/logic/systemSetting/staticConfigBiz.js'
  import { extend, getKeyByValue } from '@/utils/tool'
  import validateConfig from '@/utils/validate'
  import dynamicTable from '@/components/dynamicTable.vue'
  export default {
    mixins: [rac, dic, table],
    components: {
      dynamicTable
    },
    props: ['siteCode'],
    data () {
      const that = this
      return {
        form: {
          group: '',
          appName: '',
          ip: ''
        },
        staticForm: {
          group: '',
          appName: '',
          logLevel: '',
          log1Level: '',
          uploadLevel: '',
          instanceLogLevels: []
        },
        tableControl: [
          {
            label: that.$t('common.edit'),
            callback: that.e_add,
            rac: () => that.gRac('staticConfig@update')
          }, {
            label: that.$t('common.delete'),
            callback: that.e_delete,
            rac: () => that.gRac('staticConfig@delete')
          }
        ],
        dialogFormShow: false,
        dialogTitle: '',
        dialogData: [],
        dialogModel: {},
        dialogFormRule: {
          group: [{ ...validateConfig.common.notEmpty }],
          appName: [{ ...validateConfig.common.notEmpty }],
          logLevel: [{ ...validateConfig.common.notEmpty }],
          log1Level: [{ ...validateConfig.common.notEmpty }],
          uploadLevel: [{ ...validateConfig.common.notEmpty }]
        },
        select_log: {},
        select_app: {},
        select_ip: {},
        inputData: [],
        tableModel: {},
        isAmend: false,
        checked: false,
        init: true,
        groupList: {}
      }
    },
    computed: {
    },
    methods: {
      async preInitTable () {
        await Promise.all([
          this.dGetGroup(),
          this.dGetDictionaryByCode('logLevel'),
          staticConfigBiz.getHostIps().then((res) => {
            res.map(item => {
              this.select_ip[item] = item
            })
          })
        ])
        this.groupList = this.$store.state.dicModule.group
        this.select_log = this.dDictionary.logLevel
        this.initTable()
        this.setDynamicData()
      },
      async waitAppList (group) {
        await this.dGetAppByGroup('', group)
        this.select_app = { ...this.dDictionaryApp[group] }
        if (this.isAmend && !this.dialogFormShow) return
        this.staticForm.appName = Object.keys(this.select_app)[0]
      },
      e_search () {
        this.tResetPage()
        this.search()
      },
      initTable () {
        this.tInitTable({
          lanKey: 'logComponentManage.table',
          head: ['appName', 'group', 'uploadLevel', 'updateTime'],
          requestFun: this.search,
          headOpt: {
            group: {
              formatter: 'Dictionary',
              formatterDic: this.groupList
            },
            updateTime: {
              formatter: 'Date'
            },
            uploadLevel: {
              formatter: 'Dictionary',
              formatterDic: this.select_log
            }
          }
        })
      },
      setDynamicData () {
        this.inputData = [
          {
            label: this.$t('logComponentManage.ip'),
            key: 'ip',
            type: 'select',
            select: this.select_ip
          },
          {
            label: this.$t('logComponentManage.logLevel'),
            key: 'logLevel',
            type: 'select',
            select: this.select_log
          },
          {
            label: this.$t('logComponentManage.log1Level'),
            key: 'log1Level',
            type: 'select',
            select: this.select_log
          },
          {
            label: this.$t('logComponentManage.uploadLevel'),
            key: 'uploadLevel',
            type: 'select',
            select: this.select_log
          }
        ]
        this.tableModel = {
          ip: Object.keys(this.select_ip)[0],
          logLevel: Object.keys(this.select_log)[0],
          log1Level: Object.keys(this.select_log)[0],
          uploadLevel: Object.keys(this.select_log)[0]
        }
      },
      search () {
        const reqData = extend(true, { ...this.tPageInfo }, this.form)
        reqData.siteCode = this.siteCode
        staticConfigBiz.getStaticConfig(reqData).then((data) => {
          this.tData = data
        })
      },
      e_add (rowData) {
        if (rowData) {
          this.isAmend = true
          this.dialogTitle = this.$t('common.edit')
          this.staticForm = {
            group: getKeyByValue(this.groupList, rowData.group),
            appName: rowData.appName,
            logLevel: rowData.logLevel,
            log1Level: rowData.log1Level,
            uploadLevel: rowData.uploadLevel,
            instanceLogLevels: rowData.instanceLogLevels,
            id: rowData.id
          }
          this.checked = rowData.instanceLogLevels.length !== 0
        } else {
          this.isAmend = false
          this.dialogTitle = this.$t('common.add')
          this.staticForm = {
            group: Object.keys(this.groupList)[0],
            appName: '',
            logLevel: Object.keys(this.select_log)[0],
            log1Level: Object.keys(this.select_log)[0],
            uploadLevel: Object.keys(this.select_log)[0],
            instanceLogLevels: []
          }
          this.checked = false
        }
        this.dialogFormShow = true
        this.$nextTick(() => {
          this.$refs.dynamicTable.setData(this.staticForm.instanceLogLevels)
        })
      },
      e_cancel () {
        this.dialogFormShow = false
      },
      e_save () {
        this.staticForm.instanceLogLevels = this.checked ? this.$refs.dynamicTable.getData() : []
        this.staticForm.siteCode = this.siteCode
        this.$refs.staticForm.validate((valid) => {
          if (valid) {
            if (this.isAmend) {
              staticConfigBiz.updateStaticConfig(this.staticForm).then(() => {
                this.$message({
                  message: this.$t('common.success'),
                  type: 'success'
                })
                setTimeout(() => {
                  this.dialogFormShow = false
                  this.e_search()
                }, 500)
              })
            } else {
              staticConfigBiz.addStaticConfig(this.staticForm).then(() => {
                this.$message({
                  message: this.$t('common.success'),
                  type: 'success'
                })
                setTimeout(() => {
                  this.dialogFormShow = false
                  this.e_search()
                }, 500)
              })
            }
          }
        })
      },
      e_delete (rowData) {
        this.$confirm(this.$t('common.deleteTips'), this.$t('common.tips'), {
          type: 'warning'
        }).then(() => {
          staticConfigBiz.deleteStaticConfig({ id: rowData.id, siteCode: this.siteCode }).then((data) => {
            this.$message({
              message: this.$t('common.success'),
              type: 'success'
            })
            this.search()
          })
        }).catch(() => {
  
        })
      },
      deleteDdata (item, i) {
        const d = this.$refs.dynamicTable.getData()
        d.splice(i, 1)
        this.$refs.dynamicTable.setData(d)
      }
    },
    mounted () {},
    watch: {
      'staticForm.group' () {
        this.waitAppList(this.staticForm.group)
      },
      'siteCode' () {
        if (this.init) {
          this.init = false
          this.preInitTable()
          this.e_search()
        } else {
          this.e_search()
        }
      }
    }
  }
</script>

              
              
              
              
              
              
              